import classNames from 'classnames';
import { PureComponent } from 'react';

import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import errorImg from 'images/artwork/icons/error_reporting.svg';

class FITBDecorator extends PureComponent {
  render() {
    const {
      children,
      contentState,
      entityKey,
      fitbInputs,
      onFITBChange,
      onOverrideMark,
      onToggleSolutionKey,
      readOnly,
      showSolutions,
      solutionToggleClassName,
      solutionVisibleClassName,
      submissionResults,
    } = this.props;
    const { id, value } = contentState.getEntity(entityKey).getData();

    if (onFITBChange) {
      const val = fitbInputs?.[id];
      return (
        <div css={inputCss}>
          <input
            className={classNames(
              'FITB-input',
              submissionResults && {
                'FITB-input_success': submissionResults[id],
                'FITB-input_fail': !submissionResults[id],
              },
            )}
            disabled={Boolean(submissionResults)}
            onChange={e => onFITBChange({ ...fitbInputs, [id]: e.target.value })}
            // style={{ width: submissionResults ? value.length * 15 : 'auto' }}
            style={{ width: `${value ? value.length + 4 : 10}ch` }}
            value={val || ''}
          />
          {submissionResults && !submissionResults[id] && (
            <div className="FITB-correctResult">
              {value}
              {val && onOverrideMark && (
                <Tooltip title="Report marking error">
                  <IconButton onClick={() => onOverrideMark(id)} size="small">
                    <img height="16" src={errorImg} width="16" />
                  </IconButton>
                </Tooltip>
              )}
            </div>
          )}
        </div>
      );
    }

    // If the showSolutions props is true, the "Show Solutions" button was
    // clicked and solutions can only be hidden by clicking the "Show Solutions"
    // button again
    if (showSolutions === true) {
      return (
        <div className={classNames('root_solutionVisible', solutionVisibleClassName)} css={rootCss}>
          {children}
          <hr className="FITB-underline" />
        </div>
      );
    }

    const showSolution = !readOnly || showSolutions?.[id];

    if (onToggleSolutionKey) {
      return (
        <Tooltip disableInteractive title={showSolution ? 'Hide Solution' : 'Show Solution'}>
          <div
            className={classNames(
              'root_solutionToggle',
              solutionToggleClassName,
              {
                root_solutionVisible: showSolution,
                root_solutionHidden: !showSolution,
              },
              showSolution && solutionVisibleClassName,
            )}
            css={rootCss}
            onClick={() => onToggleSolutionKey(id)}
          >
            {children}
            <hr className="FITB-underline" />
          </div>
        </Tooltip>
      );
    }

    return (
      <div
        className={classNames(
          {
            root_readOnly: readOnly,
            root_solutionVisible: showSolution,
            root_solutionHidden: !showSolution,
          },
          showSolution && solutionVisibleClassName,
        )}
        css={rootCss}
      >
        {children}
        <hr className="FITB-underline" />
      </div>
    );
  }
}

const rootCss = ({ palette, spacing }) => ({
  position: 'relative',
  display: 'inline-block',
  verticalAlign: 'baseline',
  padding: spacing(0.25, 2),
  margin: '1px 0',
  borderRadius: spacing(1, 1, 0, 0),

  '&.root_solutionHidden:not(.root_readOnly) > :not(.FITB-underline)': { filter: 'blur(4px)' },
  '&.root_solutionVisible': { backgroundColor: palette.primary.background },
  '&.root_readOnly': {
    '&.root_solutionHidden > :not(.FITB-underline)': {
      opacity: 1,
      visibility: 'hidden',
    },
  },
  '&.root_solutionToggle': {
    cursor: 'pointer',
    backgroundColor: palette.primary.background,
    '&:hover': { backgroundColor: palette.primary.light },
  },
  '.FITB-underline': {
    margin: 0,
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
  },
});

const inputCss = ({ palette, spacing, typography }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  '.FITB-input': {
    borderRadius: spacing(2),
    padding: 4,
    border: `2px solid ${palette.form.input}`,
    '&:hover': { borderColor: palette.form.inputHover },
    '&:focus': {
      outline: 'none',
      borderColor: palette.primary.main,
    },
    '&.FITB-input_success': { borderColor: palette.success.main },
    '&.FITB-input_fail': { borderColor: palette.error.main },
  },
  '.FITB-correctResult': {
    marginLeft: spacing(1),
    fontWeight: typography.fontWeightExtraBold,
    color: palette.success.main,
  },
});

export default {
  strategy: (contentBlock, callback, contentState) => {
    contentBlock.findEntityRanges(character => {
      const entityKey = character.getEntity();
      return entityKey !== null && contentState.getEntity(entityKey).getType() === 'FILL_IN_THE_BLANK';
    }, callback);
  },
  component: FITBDecorator,
};
